/** Max-age (seconds) for persistent locale cookies — keep in sync with `src/proxy.ts`. */
const LOCALE_PREFERENCE_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

/** Session-scoped locale chosen via the header selector while logged in. */
export const LOCALE_SESSION_OVERRIDE_COOKIE = 'localeSessionOverride';

/** Persistent mirror of the logged-in profile preferred language + country. */
export const PROFILE_PREFERRED_LOCALE_COOKIE = 'profilePreferredLocale';

export default LOCALE_PREFERENCE_COOKIE_MAX_AGE;
